import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizePipe } from '../../../localize/localize.pipe';

interface ContactPhone {
  contactPhoneDisplayed: string;
  contactPhoneLinked: string;
}

@Component({
  selector: 'app-navbar-top-bar',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, LocalizePipe],
  templateUrl: './navbar-top-bar.component.html',
  styleUrls: ['./navbar-top-bar.component.scss']
})
export class NavbarTopBarComponent {
  @Input() isLoggedIn = false;
  @Input() isStudent = false;
  @Input() isTeacher = false;
  @Input() showTutorGuideButton = false;
  @Input() contactVariable$: Promise<ContactPhone> | null = null;
}
